export default "__VITE_ASSET__CeNoh2HO__"